<template>
  <!-- 公告 -->
  <div id="notice">
    <div class="bn-title">{{title}}</div>
    <vue-seamless-scroll
      :data="list"
      :class-option="optionLeft"
      class="seamless-warp2"
    >
      <ul class="item">
        <li
          v-for="(item, index) in list"
          :key="index"
          v-text="item.content"
        ></li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getNotices();
  },
  methods: {
    async getNotices() {
      var _this = this;
      var data = {
        createdAt: "",
        currentPage: "",
        pageSize: "",
        publishedAt: "",
        subject: "",
        type: "",
      };
      var res = await _this.$http.post(_this.$api.noticeList, data);

      if (res.code == 0) {
        this.list = res.data.content;

      
      } else {
        this.$message.error(res.msg);
      }
    },
  },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: this.list.length,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#notice {
  display: flex;
  justify-content: center;
}
.bn-title {
  float: left;
  // width: 100px;
  // height: 36px;
  padding: 9px 20px 0;
  // line-height: 36px;
  white-space: nowrap;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  text-indent: 34px;
  color: #ffe371;
//   background: url(../../static/image/pn/icons.png) no-repeat 0;
  background: url(../../assets/image/public/icons.png) no-repeat 0;
  background-position: -145px -133px;
  cursor: pointer;
}
.seamless-warp2 {
  overflow: hidden;
  height: 36px;
  background: rgba(0, 0, 0, 0.6);
  line-height: 36px;
  width: 1100px;
  color: #fff;
  ul.item {
    // width:1100px;
    li {
      white-space: nowrap;
      float: left;
      margin-right: 10px;
    }
  }
}
</style>
